import templateUrl from './registration/registration.html';
import controller from './registration/registrationController';

export default {
  controller,
  controllerAs: 'registrationController',
  templateUrl
};
